import { z } from 'zod'

export const TermsStatus = z.object({
  current_version: z.string(),
  published_at: z.string().datetime({ offset: true }),
  effective_at: z.string().datetime({ offset: true }),
  material_version: z.string().nullable(),
  governing_version: z.string().nullable(),
  accepted_version: z.string().nullable(),
  accepted_at: z.string().datetime({ offset: true }).nullable(),
  needs_acceptance: z.boolean(),
  can_accept: z.boolean(),
  notice_sent_at: z.string().datetime({ offset: true }).nullable()
})

export type TermsStatus = z.infer<typeof TermsStatus>
